import React from 'react'
import './About.css'
import ME from '../../assets/me-about.jpg'
import { FaAward } from 'react-icons/fa'
import { FiUser } from 'react-icons/fi'
import { VscRootFolderOpened } from 'react-icons/vsc'


const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about_container'>
        <div className='about_me'>
          <div className='about_me-image'>

            <img src={ME} alt='About_image' />
          </div>
        </div>

        <div className='about_content'>
          <div className='about_cards'>
            <article className='about_card'>
              <FaAward className='about_icon' />
              <h5>Experience</h5>
              <small> 3+ Years working</small>
            </article>

            <article className='about_card'>
              <FiUser className='about_icon' />
              <h5>Clients</h5>
              <small> 20+ Worldwide</small>
            </article>

            <article className='about_card'>
              <VscRootFolderOpened className='about_icon' />
              <h5>Project</h5>
              <small>30+ Project</small>
            </article></div>
          <div className='ex'>
            <h2>Hi, I’m Gurpreet 😊</h2>
            <p>
              I have 3+ years of experience in building and maintaining responsive web applications using JavaScript technologies.
              I really enjoy being challenged working on complex projects that require programming skills, which help me enhance my knowledge.
            </p>
          </div>

          <a href='#contact' className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>


    </section>
  )
}

export default About